var map = {
	"./classification-section/classification-list/classification-list.module": [
		"./src/app/classification-section/classification-list/classification-list.module.ts",
		"classification-section-classification-list-classification-list-module"
	],
	"./dashboardreport/dashboardreport.module": [
		"./src/app/dashboardreport/dashboardreport.module.ts",
		"dashboardreport-dashboardreport-module"
	],
	"./detail-order-lazy/detail-order-lazy.module": [
		"./src/app/detail-order-lazy/detail-order-lazy.module.ts",
		"detail-order-lazy-detail-order-lazy-module"
	],
	"./programming-list/programming-calendar/programming-calendar.module": [
		"./src/app/programming-list/programming-calendar/programming-calendar.module.ts",
		"default~programming-list-programming-calendar-programming-calendar-module~programming-list-programmi~f011618f",
		"programming-list-programming-calendar-programming-calendar-module"
	],
	"./programming-list/programming-fullcalendar/programming-fullcalendar.module": [
		"./src/app/programming-list/programming-fullcalendar/programming-fullcalendar.module.ts",
		"default~programming-list-programming-calendar-programming-calendar-module~programming-list-programmi~f011618f",
		"programming-list-programming-fullcalendar-programming-fullcalendar-module"
	],
	"./user-list/modal-image/modal-image.module": [
		"./src/app/user-list/modal-image/modal-image.module.ts",
		"user-list-modal-image-modal-image-module"
	],
	"./view-report-pdf/view-report-pdf.module": [
		"./src/app/view-report-pdf/view-report-pdf.module.ts",
		"view-report-pdf-view-report-pdf-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;